module.exports = __webpack_public_path__ + "img/heera.4e321248.svg";